module.exports = __webpack_public_path__ + "static/fleecedinohamper-d6c767683e9e3faf679e09c88e2279b4.jpeg";